<div class="pin-reset-container">
  <!-- Steps container valid for Email and Postal Address only -->
  <div class="pin-container hide1">
    <div class="step-container flex justify-space-between">
      <div class="step-1 flex">
        <span class="step-val "
          [ngClass]="{ 'active' :rootScope.activeCustTab.pinReset?.step1Active || rootScope.activeCustTab.pinReset?.step1Complete }">
          <span class="step-circle " [ngClass]="rootScope.activeCustTab.pinReset?.step1Active? 'active' : 'complete'">
            <span *ngIf="rootScope.activeCustTab.pinReset?.step1Complete"> <i class="fa-solid fa-check"></i></span>
            <span class="step-no" *ngIf="rootScope.activeCustTab.pinReset?.step1Active">1</span>
          </span>
          <span>Select delivery method</span>
        </span>
      </div>
      <div class="step-2 flex">
        <span class="step-val "
          [ngClass]="{ 'active' :rootScope.activeCustTab.pinReset?.step2Active || rootScope.activeCustTab.pinReset?.step2Complete }">
          <span class="step-circle"
            [ngClass]="{ 'active' :rootScope.activeCustTab.pinReset?.step2Active,'complete': rootScope.activeCustTab.pinReset?.step2Complete,'failure':rootScope.activeCustTab.pinReset?.step2Failed}">
            <span *ngIf="rootScope.activeCustTab.pinReset?.step2Complete"> <i class="fa-solid fa-check"></i></span>
            <span *ngIf="rootScope.activeCustTab.pinReset?.step2Failed">   <i class="fa-solid fa-xmark"></i></span>
            <span class="step-no" *ngIf="!rootScope.activeCustTab.pinReset?.step2Complete && !this.rootScope.activeCustTab.pinReset.step2Failed">2</span>
          </span>
          <span>Verify delivery address</span>
        </span>
        
      </div>
      <div class="step-3 flex">
        <span class="step-val "
          [ngClass]="{ 'active' :rootScope.activeCustTab.pinReset?.step3Active || rootScope.activeCustTab.pinReset?.step3Complete }">
          <span class="step-circle"
            [ngClass]="{ 'active' :rootScope.activeCustTab.pinReset?.step3Active,'complete': rootScope.activeCustTab.pinReset?.step3Complete,'failure':rootScope.activeCustTab.pinReset?.step3Failed}">
            <span *ngIf="rootScope.activeCustTab.pinReset?.step3Complete"> <i class="fa-solid fa-check"></i></span>
            <span *ngIf="rootScope.activeCustTab.pinReset?.step3Failed"> <i class="fa-solid fa-xmark"></i></span>
            <span class="step-no" *ngIf="!rootScope.activeCustTab.pinReset?.step3Complete && !this.rootScope.activeCustTab.pinReset.step3Failed">3</span>
          </span>
          <span>Confirm and send</span>
        </span>
       
      </div>
    </div>
  </div>

  <div class="select-delivery-method hide1" *ngIf="rootScope.activeCustTab.pinReset?.step1Active">

    <f-alert variant="error" class="status-msg" *ngIf="allMethodDisabled">No delivery method has been configured for the client. Contact myIT.</f-alert>
    <mat-radio-group color="primary" class="account-selection hide1" disableRipple aria-label="Select an option"
      [(ngModel)]="rootScope.deliveryOption" (change)="selectedMethod($event.value)">
      <mat-radio-button class="delivery-method-button" *ngFor="let method of rootScope.activeCustTab.deliveryMethod"
        [value]="method?.value" [disabled]="method?.disabled">
        {{method.label}}
      </mat-radio-button>
    </mat-radio-group>
    <div class="btn-controls">
      <f-button text="Back" title="Back" type="button" variant="action" class="hide"></f-button>
      <f-button text="Continue" title="Continue"  [ngClass]="{disableBtn:allMethodDisabled}" [disabled]="allMethodDisabled" *ngIf="rootScope.activeCustTab.pinReset?.step1Active" (click)="pinResetContinueStep1()" type="button" variant="progressive"
        class=""></f-button>
    </div>
  </div>
  <div class="email-method hide1" *ngIf="rootScope.deliveryOption =='email'" >
    <div class="email-step-content hide1" *ngIf="rootScope.activeCustTab.pinReset?.step2Active">
      <f-alert variant="info" class="status-msg">Ask the customer to verify the email address below. If it’s incorrect, do not share the listed email address.</f-alert>
      <p class="pin-content">
        The temporary PIN will be sent to: <strong>{{rootScope.emailList}}</strong>
      </p>
    </div>
     <p class="pin-content hide1" *ngIf="rootScope.activeCustTab.pinReset?.step3Active">
      The temporary PIN will be sent to: <strong>{{rootScope.emailList}}</strong>
    </p>

    <div class="success-msg hide1"  *ngIf="rootScope.activeCustTab.pinReset?.step3Complete">
      <f-alert variant="success" class="status-msg">Success! The PIN Reset is complete.</f-alert>

      <p><strong>A temporary PIN has been sent to {{rootScope.emailList}}</strong></p>
      <p>The temporary PIN is single-use, valid for 15 minutes, and will allow the customer to log in and create a new
        PIN.</p>


    </div>
    <div class="failure-msg" *ngIf="this.rootScope.activeCustTab.pinReset.step2Failed || this.rootScope.activeCustTab.pinReset.step3Failed">
      <f-alert variant="error" class="status-msg">{{rootScope.pinRestErrorMsg}}</f-alert>
    </div>

    <div class="btn-controls">
      <f-button text="Back" title="Back"  *ngIf="rootScope.activeCustTab.pinReset?.step2Active || this.rootScope.activeCustTab.pinReset?.step2Failed" (click)="pinResetEmailBackStep2()" type="button" variant="action" class="hide1"></f-button>
      <f-button text="Continue" title="Continue"  *ngIf="rootScope.activeCustTab.pinReset?.step2Active && !this.rootScope.activeCustTab.pinReset.step2Failed" (click)="pinResetEmailContinueStep2()" type="button" variant="progressive" class="hide1"></f-button>
      <f-button text="Back" title="Back" *ngIf="rootScope.activeCustTab.pinReset?.step3Active || rootScope.activeCustTab.pinReset?.step3Failed" (click)="pinResetEmailBackStep3()" type="button" variant="action" class="hide1"></f-button>
      <f-button text="Send PIN" title="Send PIN" *ngIf="rootScope.activeCustTab.pinReset?.step3Active" (click)="sendPinEmail()"  type="button" variant="progressive" class="hide1"></f-button>
    </div>
  </div>
  <div class="postal-address hide1" *ngIf="rootScope.deliveryOption =='postal'" >
    <div class="postal-step-content hide1" *ngIf="rootScope.activeCustTab.pinReset?.step2Active">
      <f-alert variant="info" class="status-msg">Ask the customer to verify the address below. If it’s incorrect, do not share any listed address.</f-alert>
      <p class="pin-content">
        The temporary PIN will be sent to: <strong>{{rootScope.postalAddress}}</strong>
      </p>          
      <p class="pin-content" *ngIf="rootScope?.tempAddressEnabled">
        Need to set a temporary address? <a tabindex="0" href="javascript:void(0);" (click)="goToTempAddressTbaGui()" >Go to TBA</a> to process a temporary address and then <a tabindex="0"
        ref="javascript:void(0);" (click)="refreshTempAddress()">click
          here to refresh.</a>          
      </p>          
    </div>          
    <p class="pin-content hide1"  *ngIf="rootScope.activeCustTab.pinReset?.step3Active">
      The temporary PIN will be sent to: <strong>{{rootScope.postalAddress}}</strong>
    </p>          
    <div class="success-msg hide1" *ngIf="rootScope.activeCustTab.pinReset?.step3Complete">
      <f-alert variant="success" class="status-msg">Success! The PIN Reset is complete.</f-alert>
      <p class="hide1"><strong>A temporary PIN has been sent to {{rootScope.postalAddress}}.</strong></p>
      <p>The temporary PIN is single-use, valid for 30 days, and will allow the customer to log in and create a new
        PIN.</p>
    </div>
    <div class="failure-msg hide1" *ngIf="rootScope.activeCustTab.pinReset?.step2Failed || this.rootScope.activeCustTab.pinReset.step3Failed">
      <f-alert variant="error" class="status-msg">{{rootScope.pinRestErrorMsg}}</f-alert>
    </div>
    <div class="btn-controls">
      <f-button text="Back" title="Back" *ngIf="rootScope.activeCustTab.pinReset?.step2Active || rootScope.activeCustTab.pinReset?.step2Failed" (click)="pinResetBackStep2()" type="button" variant="action" class="hide1"></f-button>
      <f-button text="Back" title="Back" *ngIf="rootScope.activeCustTab.pinReset?.step3Active || rootScope.activeCustTab.pinReset?.step3Failed" (click)="pinResetBackStep3()" type="button" variant="action" class="hide1"></f-button>
      <f-button text="Continue" title="Continue" *ngIf="rootScope.activeCustTab.pinReset?.step2Active" (click)="pinResetContinueStep2()" type="button" variant="progressive" class="hide1"></f-button>
      <f-button text="Send PIN" title="Send PIN" *ngIf="rootScope.activeCustTab.pinReset?.step3Active" (click)="sendPin()" type="button" variant="progressive" class="hide1"></f-button>
    </div>

  </div>

</div>